import { MainMenu } from './mainMenu';
import type { ServerInfo, Account } from '../net';

// Front door. The whole pre-game flow (sign-in -> server browser -> spawn) now lives in the owner-designed
// two-pane MainMenu window; Frontend is a thin adapter that preserves main.ts's contract
// (new Frontend(onSpawn) + hide()). onSpawn boots the game for the chosen server + account.
export class Frontend {
  private readonly menu: MainMenu;

  constructor(onSpawn: (server: ServerInfo, account: Account) => void) {
    this.menu = new MainMenu(onSpawn);
  }

  hide(): void {
    this.menu.hide();
  }
}
